import { msg } from '@gonfalon/messages/msg';
import moment from 'moment';

import type { DateRangePreset } from './types';

export const presetLabel = (preset: DateRangePreset) =>
  preset.label || msg('observability.dateRangePicker.presetFallback', { quantity: preset.quantity, unit: preset.unit });

export const presetValue = (preset: DateRangePreset) => preset.value || `last_${preset.quantity}_${preset.unit}`;

export const parsePreset = (presetVal: string): DateRangePreset => {
  const [, quantity, unit] = presetVal.split('_');
  return {
    quantity: Number(quantity),
    unit: unit as moment.DurationInputArg2,
  };
};

export const presetStartDate = (preset: DateRangePreset, endDate = new Date()): Date =>
  moment(endDate).subtract(preset.quantity, preset.unit).toDate();

/**
 * Generates a short label for a date range (e.g., "15m", "4h", "7d", "3mo")
 */
export const getPresetLabel = (startDate: Date, endDate: Date): string => {
  const diffMs = endDate.getTime() - startDate.getTime();

  const minutes = diffMs / (1000 * 60);
  const hours = diffMs / (1000 * 60 * 60);
  const days = diffMs / (1000 * 60 * 60 * 24);

  if (minutes < 60) {
    return msg('observability.dateRangePicker.durationMinutes', { count: Math.round(minutes) });
  } else if (hours <= 24) {
    return msg('observability.dateRangePicker.durationHours', { count: Math.round(hours) });
  } else if (days <= 30) {
    return msg('observability.dateRangePicker.durationDays', { count: Math.round(days) });
  } else {
    const months = Math.round(days / 30);
    return msg('observability.dateRangePicker.durationMonths', { count: months });
  }
};
